import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { collectionDoc } from "../../collectionRef/collectionOperations";
import { Profile } from "@/models/database/profiles/profile.model";

export async function _getUserBasedOnUid(uid: string) {
  const _profile = await collectionDoc.profiles(uid, brand.tenantId);
  const profile = _profile.data() as Profile;
  return profile;
}
